import { __extends } from "tslib";
// DS: C33A
/** Bottom section of a thumb, containing related information */
import React from 'react';
import classnames from 'classnames';
import Flex from '../Flex';
import UserAvatar from '../User/Avatar';
import UserLink from '../User/Link';
import Timestamp from '../Timestamp';
import DeviationLink from '../Duperbrowse/DeviationLink';
import { withMobileContext, } from '@wix/da-react-context/pkg/MobileContext';
import s from './ThumbInfo.scss';
var ThumbInfo = /** @class */ (function (_super) {
    __extends(ThumbInfo, _super);
    function ThumbInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ThumbInfo.prototype.render = function () {
        var _a = this.props, user = _a.user, title = _a.title, timestamp = _a.timestamp, height = _a.height, extra = _a.extra, isMobile = _a.isMobile;
        if (title) {
            return isMobile ? this.renderWithTitleMobile() : this.renderWithTitle();
        }
        return (React.createElement(Flex, { className: classnames(s['root'], s['without-title']), alignItems: "center", style: { height: height } },
            React.createElement(UserAvatar, { size: isMobile ? 24 : 32, user: user, className: s['avatar'] }),
            React.createElement(UserLink, { user: user, className: s['username'], biData: {
                    creatorid: user.useridUuid,
                } }),
            timestamp && (React.createElement(Timestamp, { timestamp: timestamp, className: s['timestamp'] })),
            extra));
    };
    ThumbInfo.prototype.renderWithTitleMobile = function () {
        var _a = this.props, user = _a.user, timestamp = _a.timestamp, extra = _a.extra, isMobile = _a.isMobile;
        return (React.createElement("div", { className: classnames(s['root'], s['with-title']) },
            React.createElement("div", { className: s['info'] },
                this.renderTitle(s['title']),
                React.createElement(Flex, { className: s['secondRow'], alignItems: "center" },
                    React.createElement(UserAvatar, { size: isMobile ? 24 : 32, user: user, className: s['avatar'] }),
                    React.createElement(UserLink, { user: user, className: s['username'], biData: {
                            creatorid: user.useridUuid,
                        } }),
                    timestamp && (React.createElement(Timestamp, { timestamp: timestamp, className: s['timestamp'] })))),
            extra ? (React.createElement(Flex, { className: s['extra'], alignItems: "center" }, extra)) : null));
    };
    ThumbInfo.prototype.renderWithTitle = function () {
        var _a = this.props, user = _a.user, timestamp = _a.timestamp, extra = _a.extra, isMobile = _a.isMobile;
        return (React.createElement(Flex, { className: classnames(s['root'], s['with-title']), alignItems: "center" },
            React.createElement(UserAvatar, { size: isMobile ? 24 : 32, user: user, className: s['avatar'] }),
            React.createElement("div", { className: s['info'] },
                this.renderTitle(s['title']),
                React.createElement(Flex, { alignItems: "center" },
                    React.createElement(UserLink, { user: user, className: s['username'], biData: {
                            creatorid: user.useridUuid,
                        } }),
                    timestamp && (React.createElement(Timestamp, { timestamp: timestamp, className: s['timestamp'] })))),
            extra));
    };
    ThumbInfo.prototype.renderTitle = function (titleClass) {
        var _a = this.props, title = _a.title, urlDeviation = _a.urlDeviation, link = _a.link;
        if (urlDeviation) {
            return (React.createElement(DeviationLink, { className: titleClass, deviation: urlDeviation }, title));
        }
        if (link) {
            return (React.createElement("a", { className: titleClass, href: link }, title));
        }
        return React.createElement("h4", { className: titleClass }, title);
    };
    return ThumbInfo;
}(React.Component));
export default withMobileContext(ThumbInfo);
//# sourceMappingURL=ThumbInfo.js.map